export default __webpack_public_path__ + "static/media/V450_V470_22A00101A.b8ace21d.STEP";